export default [
  {
    name: 'All start-ups',
    series: 'start-ups',
    sets: ['start-ups'],
    dataLabels: {
      enabled: false,
    },
  },
  {
    name: 'Digital',
    series: 'digital',
    sets: ['Digital'],
  },
  {
    name: 'Digital start-ups',
    series: 'digital',
    sets: ['Digital', 'start-ups'],
    dataLabels: {
      enabled: false,
    },
  },
  {
    name: 'Energy',
    series: 'energy',
    sets: ['Energy'],
  },
  {
    name: 'Energy start-ups',
    series: 'energy',
    sets: ['Energy', 'start-ups'],
    dataLabels: {
      enabled: false,
    },
  },
  {
    name: 'Digital energy',
    series: 'digital_energy',
    sets: ['Digital', 'Energy'],
    dataLabels: {
      enabled: false,
    },
  },
  {
    name: 'Digital energy start-ups',
    series: 'digital_energy',
    sets: ['Digital', 'Energy', 'start-ups'],
    dataLabels: {
      enabled: false,
    },
  },
  {
    name: 'Clean',
    series: 'green',
    sets: ['Green'],
  },
  {
    name: 'Green start-ups',
    series: 'green',
    sets: ['Green', 'start-ups'],
    dataLabels: {
      enabled: false,
    },
  },
  {
    name: 'Clean energy',
    series: 'green_energy',
    sets: ['Green', 'Energy'],
    dataLabels: {
      enabled: false,
    },
  },
  {
    name: 'Clean energy start-ups',
    series: 'green_energy',
    sets: ['Energy', 'Green', 'start-ups'],
    dataLabels: {
      enabled: false,
    },
  },
  {
    name: 'Digital & clean',
    series: 'digital_green',
    sets: ['Digital', 'Green'],
    dataLabels: {
      enabled: false,
    },
  },
  {
    name: 'Digital & clean start-ups',
    series: 'digital_green',
    sets: ['Digital', 'Green', 'start-ups'],
    dataLabels: {
      enabled: false,
    },
  },
  {
    name: 'Digital & clean energy',
    series: 'digital_green_energy',
    sets: ['Digital', 'Green', 'Energy'],
    dataLabels: {
      enabled: false,
    },
  },
  {
    name: 'Digital & clean energy start-ups',
    series: 'digital_green_energy',
    sets: ['Digital', 'Green', 'Energy', 'start-ups'],
    dataLabels: {
      enabled: false,
    },
  },
];
